import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConcatNamePipe } from './pipes/concat-name.pipe';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { LocalDateTimePipe } from './pipes/local-date-time.pipe';
import { PageErrorComponent } from './page-error/page-error.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SortIndicatorComponent } from './sort-indicator/sort-indicator.component';
import { RouterModule } from '@angular/router';
import { UserImageComponent } from './user-image/user-image.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ExpirationDatePipe } from './pipes/expiration-date.pipe';
import { MultiselectDropdownComponent } from './multiselect-dropdown/multiselect-dropdown.component';
import { ListFilterPipe } from './pipes/list-filter.pipe';
import { ToPascalPipe } from './pipes/to-pascal.pipe';
import { PrettySectionSequencePipe } from './form-builder-pipes/pretty-section-sequence.pipe';
import { SearchInputComponent } from './search-input/search-input.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ResponsivePaginationComponent } from './responsive-pagination/responsive-pagination.component';
import { PageBadDataComponent } from './page-bad-data/page-bad-data.component';
import { LabelErrorComponent } from './label-error/label-error.component';
import { PermissionDirective } from './directives/permission.directive';
import { ISO8601DatePipe } from './pipes/iso8601-date.pipe';
import { PageNotAuthorizedComponent } from './page-not-authorized/page-not-authorized.component';
import { TextboxCleanerComponent } from './textbox-cleaner/textbox-cleaner.component';
import { CheckedIndicatorComponent } from './checked-indicator/checked-indicator.component';
import { PanelComponent } from './panel/panel.component';
import { ModalContainerComponent } from './modal/index';
import { DisplayErrorsComponent } from './display-errors/display-errors.component';
import { ExcerptComponent } from './excerpt/excerpt.component';
import { SpinnerModule } from '@control-tower/lib';
import { Logger } from '../core/logger';
import { HasPermissionDirective } from '../components/shared/permi.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TypeaheadModule.forRoot(),
    ReactiveFormsModule,
    TooltipModule,
    SpinnerModule
  ],
  entryComponents: [ModalContainerComponent],
  declarations: [
    CheckedIndicatorComponent,
    ConcatNamePipe,
    ExpirationDatePipe,
    ISO8601DatePipe,
    LabelErrorComponent,
    ListFilterPipe,
    LocalDatePipe,
    LocalDateTimePipe,
    ModalContainerComponent,
    MultiselectDropdownComponent,
    PageBadDataComponent,
    PageErrorComponent,
    PageNotAuthorizedComponent,
    PageNotFoundComponent,
    PaginationComponent,
    PanelComponent,
    PermissionDirective,
    ResponsivePaginationComponent,
    SearchInputComponent,
    SortIndicatorComponent,
    TextboxCleanerComponent,
    ToPascalPipe,
    PrettySectionSequencePipe,
    UserImageComponent,
    DisplayErrorsComponent,
    ExcerptComponent,
    HasPermissionDirective
  ],
  exports: [
    CheckedIndicatorComponent,
    ConcatNamePipe,
    ExpirationDatePipe,
    ISO8601DatePipe,
    LabelErrorComponent,
    ListFilterPipe,
    LocalDatePipe,
    LocalDateTimePipe,
    ModalContainerComponent,
    MultiselectDropdownComponent,
    PageBadDataComponent,
    PageErrorComponent,
    PageNotAuthorizedComponent,
    PageNotFoundComponent,
    PaginationComponent,
    PanelComponent,
    PermissionDirective,
    ResponsivePaginationComponent,
    SearchInputComponent,
    SortIndicatorComponent,
    TextboxCleanerComponent,
    ToPascalPipe,
    PrettySectionSequencePipe,
    DisplayErrorsComponent,
    ExcerptComponent,
    HasPermissionDirective
  ]   
})
export class SharedModule { }
